import React, { useEffect, useState } from 'react';
import BreadCrumb from '../../shared/BreadCrumbs';
import { useSelector, useDispatch } from 'react-redux';
import AccessControl from '../../../AccessControl';
import permissions from './../../../permissionsList';
import AddCategory from './AddCategory';
import CategoryTable from './CategoryTable';
import "./Category.css";
import { loadDocCategories, setCatmoCategories, deleteCatmoCategory } from'../../../redux/actions/docCategoryAction';
import { setSaraNodeId, setCatmoNodeId } from '../../../redux/actions/docCategoryAction';


export const searchFiles = (data, input = '', dropDown = false) => {
  if (!data) {
    return dropDown ? [] : { uncategorizedFiles: [], categories: [] };
  }

	// Convert searchTerm to lowercase for case-insensitive 
	const term = input.toLowerCase();

	if (term.length <= 0) {
		return data
	}
  const filterDirectories = (directories) => {
    // if directories is null/undefined, return empty array
    if (!directories || !Array.isArray(directories)) {
      return [];
    }

    return directories
      .map((directory) => {
        // if directory is null/undefined, skip it
        if (!directory) return null;

        const isCategoryMatch = directory.name && directory.name.toLowerCase().includes(term);

        // Ensure categories exists and is an array before filtering
        const categories = directory.categories || [];
        const filteredSubDirectories = filterDirectories(categories);
        
        let filteredFiles = [];
        if (!dropDown) {
          // Ensure files exists and is an array before filtering
          const files = directory.files || [];
          filteredFiles = files.filter((file) =>
            file && file.name && file.name.toLowerCase().includes(term)
          );
        }

        if (isCategoryMatch) {
          return {
            ...directory,
            isOpen: true
          };
        }

        if (filteredFiles.length > 0 || filteredSubDirectories.length > 0) {
          return {
            ...directory,
            files: filteredFiles,
            categories: filteredSubDirectories,
            isOpen: true
          };
        }
        return null;
      })
      .filter(Boolean); // Remove null entries
  };

  if (dropDown) {
    return filterDirectories(data);
  }
  
  // checks for data structure
  const uncategorizedFiles = data.uncategorizedFiles || [];
  const categories = data.categories || [];
  
  const matchingFiles = uncategorizedFiles.filter(
    (file) => file && file.name && file.name.toLowerCase().includes(term)
  );

  return {
    uncategorizedFiles: matchingFiles,
    categories: filterDirectories(categories)
  };
}



 

function DocumentsInterface() {

  const BreadCrumbArr = [
            {link:"/main/device_main.php", display:"Dashboard", type:'php'},
            {link:"/admin/adminscr.php", display:"Administration", type:'php'},
            {link:"/administration/DocumentsAndImages/", display:"Documents and Images", type:'react'}
        ];

  
  const [search, setSearch] = useState('');
  const [showAddCategoryPopup, setShowAddCategoryPopup] = useState(false);
  const [showAddFilePopup, setShowAddFilePopup] = useState(false);
  const [showAddSubcategoryPopup, setShowAddSubcategoryPopup] = useState(false);
  const [isCategory, setIsCategory] = useState(false);
  const [categoriesList, setCategoriesList] = useState({ uncategorizedFiles: [], categories: [] });
	const [data, setData] = useState(categoriesList);
  const dispatch = useDispatch();
  const categoriesData = useSelector(state => state.docCategoryReducer.categoriesFiles);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const saraNodeId = useSelector(state => state.docCategoryReducer.saraNodeId);
  const catmoNodeId = useSelector(state => state.docCategoryReducer.catmoNodeId);
  

  const [filteredData, setFilteredData] = useState({
    uncategorizedFiles: [],
    categories: []
  });

	useEffect(() => {
  }, [categoriesList]);

  
  const isCatmoNode = (node) => {
    return node.name && (node.name.toLowerCase()) === 'catmo';
  };


    const findCatmoNodeId = (tree) => {
      if (!tree) return null;
      
      if (Array.isArray(tree)) {
        for (const node of tree) {
          const found = findCatmoNodeId(node);
          if (found) return found;
        }
        return null;
      }
      
      if (tree.name && tree.name.toLowerCase() === 'catmo') {
        return tree.id;
      }
      
      if (tree.children && Array.isArray(tree.children)) {
        for (const child of tree.children) {
          const found = findCatmoNodeId(child);
          if (found) return found;
        }
      }
      
      return null;
    };


    const findSaraNodeId = (tree) => {
    if (!tree) return null;
    
    if (Array.isArray(tree)) {
      for (const node of tree) {
        const found = findSaraNodeId(node);
        if (found) return found;
      }
      return null;
    }
    
    if (tree.name && tree.name.toLowerCase() === 'sara') {
      return tree.id;
    }
    
    if (tree.children && Array.isArray(tree.children)) {
      for (const child of tree.children) {
        const found = findSaraNodeId(child);
        if (found) return found;
      }
    }
    
    return null;
   };

   const isChildOfSara = (node) => {
    if (!node || !node.parent) return false;
  
  // Parent is object with name 'sara'
  if (typeof node.parent === 'object' && node.parent.name && 
      node.parent.name.toLowerCase() === 'sara') {
    return true;
  }
  
  // Parent ID matches Sara ID
  if (saraNodeId && (node.parent === saraNodeId || 
      (typeof node.parent === 'object' && node.parent.id === saraNodeId))) {
    return true;
  }
  
  
  return false;
};

  const isChildOfCatmo = (node) => {
    if (!node || !node.parent) return false;

    // Parent is object with name 'catmo'
    if (typeof node.parent === 'object' && node.parent.name && 
        node.parent.name.toLowerCase() === 'catmo') {
      return true;
    }
    
    // Parent ID matches Catmo ID
    if (catmoNodeId && (node.parent === catmoNodeId || 
        (typeof node.parent === 'object' && node.parent.id === catmoNodeId))) {
      return true;
    }
    
    return false;
  };
  
  const filterDocumentTree = (data) => {
    let allCategories = [];

    // Track category IDs from the API response
    const apiCategoryIds = new Set();
    
    // Helper function to collect all category IDs from the API response
    const collectCategoryIds = (node) => {
      if (!node) return;
      
      if (Array.isArray(node)) {
        node.forEach(item => collectCategoryIds(item));
        return;
      }
      
      // Add this category's ID to our set
      if (node.id) {
        apiCategoryIds.add(node.id);
      }
      
      // Check children recursively
      if (node.children && Array.isArray(node.children)) {
        node.children.forEach(child => collectCategoryIds(child));
      }
    };
    
    // Collect all category IDs from the API response
    collectCategoryIds(data);
    
    // Find the Catmo node 
    const findCatmoNode = (tree) => {
      if (!tree) return null;
      
      // Check if this is an array root level
      if (Array.isArray(tree)) {
        for (const node of tree) {
          const found = findCatmoNode(node);
          if (found) return found;
        }
        return null;
      }
      
      // Check if this is the Catmo node
      if (tree.name && (tree.name.toLowerCase() === 'catmo')) {
        return tree;
      }
      
      // Check children array if it exists
      if (tree.children && Array.isArray(tree.children)) {
        for (const child of tree.children) {
          const found = findCatmoNode(child);
          if (found) return found;
        }
      }
      
      return null;
    };

     // Find Sara node to get its children
      const findSaraNode = (tree) => {
        if (!tree) return null;
        
        if (Array.isArray(tree)) {
          for (const node of tree) {
            const found = findSaraNode(node);
            if (found) return found;
          }
          return null;
        }
        
        if (tree.name && tree.name.toLowerCase() === 'sara') {
          return tree;
        }
        
        if (tree.children && Array.isArray(tree.children)) {
          for (const child of tree.children) {
            const found = findSaraNode(child);
            if (found) return found;
          }
        }
        
        return null;
      };
    

    // Find top-level categories (sara)
    const findTopLevelCategories = (tree) => {
      let categories = [];
      
      if (!tree) return categories;
      
      // If it's an array at root level
      if (Array.isArray(tree)) {
        // Find direct children of parent sara (excluding Catmo itself)
        tree.forEach(node => {
          if (isChildOfSara(node) && !isCatmoNode(node) && node.doc_type === 'dir') {
            categories.push(transformNode(node));
          }
        });
        
        // Also look at the children property if it exists
        tree.forEach(node => {
          if (node.children && Array.isArray(node.children)) {
            node.children.forEach(child => {
              if (isChildOfSara(child) && !isCatmoNode(child) && child.doc_type === 'dir') {
                categories.push(transformNode(child));
              }
            });
          }
        });
      } else if (tree.children && Array.isArray(tree.children)) {
        // If it's not an array but has children property
        tree.children.forEach(child => {
          if (isChildOfSara(child) && !isCatmoNode(child) && child.doc_type === 'dir') {
            categories.push(transformNode(child));
          }
        });
      }
      
      return categories;
    };
    
    // Transform node to expected format
    const transformNode = (node, inheritedCatmoLineage = false) => {
    // First, determine if this is a file and capture the doc_type
    const isFile = node.doc_type !== 'dir';
    const docType = node.doc_type || (isFile ? 'media-file' : 'dir');
    // Lineage is inherited: once an ancestor is Catmo, every descendant category
    // and file below it is Catmo-managed and must stay read-only in Sara.
    // (Guard with === true so a stray .map index can never be read as truthy.)
    const hasCatmoLineage = inheritedCatmoLineage === true || isCatmoNode(node) || isChildOfCatmo(node);

    return {
      id: node.id,
      name: node.name,
      isFile: isFile,
      doc_type: docType, 
      parent: node.parent,
      parentId: node.parent,
      modified: node.modified,
      created: node.created,
      createdBy: node.created_by || null,
      alarm_device_types: node.alarm_device_types || [],
      alarm_devices: node.alarm_devices || [],
      hasCatmoLineage: hasCatmoLineage,
      // Map children to categories
      categories: Array.isArray(node.children)
        ? node.children
            .filter(c => c.doc_type === 'dir')
            .map(child => transformNode(child, hasCatmoLineage))
        : [],
      // Create files array
      files: Array.isArray(node.children) 
        ? node.children
            .filter(c => c.doc_type !== 'dir')
            .map(file => {
              // Capture file's own device associated 
              const fileDeviceTypes = file.alarm_device_types || [];
              const fileDevices = file.alarm_devices || [];
              
              return {
                id: file.id,
                name: file.name,
                file: file.file || file.url, 
                url: file.url || file.file,
                object_id: file.object_id,
                doc_type: file.doc_type || 'media-file', // Add doc_type to file objects
                mimeType: file.mimeType || file.mimetype,
                mime_content_type: file.mime_content_type,
                parentCategoryId: node.id,
                parent: node.id,
                isFile: true,
                hasCatmoLineage: hasCatmoLineage,
                alarm_device_types: fileDeviceTypes,
                alarm_devices: fileDevices,
                modified: file.modified,
                created: file.created,
                createdBy: file.created_by || null
              };
            }) 
        : []
    };
  };
      
    // Get Catmo children
    const catmoNode = findCatmoNode(data);
    const catmoChildren = catmoNode && catmoNode.children 
      ? catmoNode.children
          .filter(child => child.doc_type === 'dir')
          .map(child => transformNode(child, true))
          .filter(Boolean)
      : [];

    // Get Sara children
    const saraNode = findSaraNode(data);
    const saraChildren = saraNode && saraNode.children
      ? saraNode.children
          .filter(child => child.doc_type === 'dir')
          .map(child => transformNode(child))
          .filter(Boolean)
      : [];
    
    // Get regular categories
    // const regularCategories = findTopLevelCategories(data);
    
    // Combine both sets
    allCategories = [...catmoChildren, ...saraChildren];

    if (categoriesData && categoriesData.categories) {
    // Find categories that exist in Redux but not in the API response
    const findMissingCategoriesRecursively = (categories) => {
      categories.forEach(category => {
        if (category.id && !apiCategoryIds.has(category.id)) {
          
          // console.log(`Category ${category.name} (ID: ${category.id}) exists in Redux but not in API response`);
          
          // Dispatch action to add this ID to deletedCategoryIds
          dispatch(deleteCatmoCategory(category.id));
        }
        
        // Check subcategories recursively
        if (category.categories && category.categories.length > 0) {
          findMissingCategoriesRecursively(category.categories);
        }
      });
    };
    
    // Check all categories in Redux against the API response
    findMissingCategoriesRecursively(categoriesData.categories);
  }

    let uncategorizedFiles = [];

  // Get uncategorized files from Sara node
  if (saraNode && saraNode.children) {
    const saraFiles = saraNode.children
      .filter(child => child.doc_type !== 'dir') // Only files, not directories
      .map(file => ({
        id: file.id,
        name: file.name,
        file: file.file || file.url,
        url: file.url || file.file,
        object_id: file.object_id,
        doc_type: file.doc_type || 'media-file',
        mimeType: file.mimeType || file.mimetype,
        mime_content_type: file.mime_content_type,
        parent: null, // Uncategorized files have no parent
        parentCategoryId: null,
        isFile: true,
        hasCatmoLineage: false, 
        alarm_device_types: file.alarm_device_types || [],
        alarm_devices: file.alarm_devices || [],
        modified: file.modified,
        created: file.created,
        createdBy: file.created_by || null
      }));
    
    uncategorizedFiles = [...uncategorizedFiles, ...saraFiles];
  }

  // Get uncategorized files from Catmo node  
  if (catmoNode && catmoNode.children) {
    const catmoFiles = catmoNode.children
      .filter(child => child.doc_type !== 'dir') // Only files, not directories
      .map(file => ({
        id: file.id,
        name: file.name,
        file: file.file || file.url,
        url: file.url || file.file,
        object_id: file.object_id,
        doc_type: file.doc_type || 'media-file',
        mimeType: file.mimeType || file.mimetype,
        mime_content_type: file.mime_content_type,
        parent: null, // Uncategorized files have no parent
        parentCategoryId: null,
        isFile: true,
        hasCatmoLineage: true, // Catmo files have catmo lineage
        alarm_device_types: file.alarm_device_types || [],
        alarm_devices: file.alarm_devices || [],
        modified: file.modified,
        created: file.created,
        createdBy: file.created_by || null
      }));
    
    uncategorizedFiles = [...uncategorizedFiles, ...catmoFiles];
  }

  // console.log("Found uncategorized files from API:", uncategorizedFiles.length);
//   console.log("Uncategorized files details:", uncategorizedFiles.map(f => ({
//   id: f.id,
//   name: f.name,
//   hasFile: !!f.file,
//   hasUrl: !!f.url,
//   hasObjectId: !!f.object_id
//  })));

  return {
    categories: allCategories,
    uncategorizedFiles: uncategorizedFiles
    };
  };

  // Fetching new created Categories from loadDocCategories
  const fetchCategories = () => {
    // console.log("fetchCategories called");
    dispatch(loadDocCategories({
      setStateFunc: (data) => {
        // console.log("loadDocCategories callback received data:", data);
        // console.log("Original data from API:", data);

    // Find Sara node ID and store it
    const saraId = findSaraNodeId(data);
      if (saraId) {

        dispatch(setSaraNodeId(saraId)); 
      }

      // Find Catmo node ID and store it
      const catmoId = findCatmoNodeId(data);
        if (catmoId) {
          // console.log("Found Catmo node ID:", catmoId);
          dispatch(setCatmoNodeId(catmoId));
        }
            
        if (data && (data.children || Array.isArray(data))) {
          const filteredData = filterDocumentTree(data);
          // console.log("Filtered data with both Catmo and regular categories:", filteredData);
          
          // Update Redux store with categories only
          // Don't interfere with uncategorized files - they're managed separately
          dispatch(setCatmoCategories(filteredData));

            console.log("Setting categories data:", {
            categoriesCount: filteredData.categories.length,
            uncategorizedCount: filteredData.uncategorizedFiles.length,
            uncategorizedFiles: filteredData.uncategorizedFiles.map(f => ({ id: f.id, name: f.name }))
          });
          
          // Update local state
          setCategoriesList(filteredData);
        } else if (data.status === "success") {
          // Handle the success response format if different
          const processedData = {
            ...data.result,
            categories: data.result.categories.map(category => ({
              ...category,
              files: category.files || [],
              isFile: false
            }))
          };
          setCategoriesList(processedData);
        } else {
          console.error("Unexpected data structure:", data);
          setCategoriesList({ categories: [], uncategorizedFiles: [] });
        }
      }
    }));
  };
  
  useEffect(() => {
    fetchCategories();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run on mount
  
  useEffect(() => {
    // Process Redux state to ensure all required properties exist
    if (categoriesData) {
      const processedData = {
        uncategorizedFiles: categoriesData.uncategorizedFiles || [],
        categories: categoriesData.categories ? categoriesData.categories.map(category => ({
          ...category,
          files: category.files || [],
          isFile: false
        })) : []
      };
      setCategoriesList(processedData);
    }
  }, [categoriesData]);

 useEffect(() => {
  const filterDeletedCategories = (data) => {
    if (!data) return { uncategorizedFiles: [], categories: [] };
    
    const deletedIds = categoriesData.deletedCategoryIds || [];
    
    // Function to filter categories recursively
    const filterRecursively = (categories) => {
      if (!categories || !Array.isArray(categories)) return [];
      
      return categories
        .filter(category => !deletedIds.includes(category.id))
        .map(category => ({
          ...category,
          categories: category.categories ? filterRecursively(category.categories) : []
        }));
    };
    
    return {
      uncategorizedFiles: data.uncategorizedFiles || [],
      categories: filterRecursively(data.categories)
    };
  };
  
  // First search, then filter out deleted categories
  const searchedData = searchFiles(categoriesData, search);
  const filteredWithoutDeleted = filterDeletedCategories(searchedData);
  
  setFilteredData(filteredWithoutDeleted);
}, [search, categoriesData]);
  
//   // First search, then filter out deleted categories
//   const searchedData = searchFiles(categoriesData, search);
//   const filteredWithoutDeleted = filterDeletedCategories(searchedData);
  
//   setFilteredData(filteredWithoutDeleted);
// }, [search, categoriesData]);
 
 
  // useEffect(() => {
  //   const newFilteredData = searchFiles(categoriesData, search);
  //   setFilteredData(newFilteredData);
  // }, [search, categoriesData]);


  const handleAddItem = (isFile) => {
    if (isFile) {
      setShowAddFilePopup(true);
    } else {
      setShowAddCategoryPopup(true);
    }
    setIsCategory(!isFile);
  };

  const handlePopupClose = () => {
    setShowAddCategoryPopup(false);
    setShowAddFilePopup(false);
    setIsCategory(false);
    setShowAddSubcategoryPopup(false);
    fetchCategories();
  };
    
  const handleShowFilePopup = (categoryData) => {
  // If categoryData is passed (from clicking "Add New File" on a specific category)
  if (categoryData && typeof categoryData === 'object') {
    setSelectedCategoryId(categoryData.parentId || categoryData.parent);
    setShowAddFilePopup({
      ...categoryData,
      mode: 'FILE'
    });
  } else {
    // If no specific category (from top-level "Add File" button)
    setSelectedCategoryId(categoryData);
    setShowAddFilePopup(true);
  }
};

 
 
    
    return (
      <div className="w-full min-h-screen bg-white-50">
        <nav className="width-100 flex-spread padding-5 table-header flex-spread">
           <div className="flex-start width-100 documents-breadcrumb">
              <BreadCrumb linkArr={BreadCrumbArr}></BreadCrumb>
           </div>      
        </nav>
  
        <div className='documents-container'>
          <div className="documents-header">
            <h1 className="button-no-button button-sm text-medium text-medium no-margin text-regular text-white">
              Documents and Images
            </h1>
          </div>
  
          <div className='documents-content'>
            <div className='users-list__filter'>
              <button 
                className='catmo-button text-medium-small text-white'
                data-testid="add-category-btn" 
                id="add-event" 
                onClick={() => handleAddItem(false)}
              >
                Add Category
              </button>
              <button 
                className='catmo-button text-medium-small text-white'
                data-testid="add-files-btn" 
                id="add-event" 
                onClick={() => handleAddItem(true)}
              >
                Add New File
              </button>
              <div className="search mustering-location-search-filter documents-search">
                <input
                  type="text"
                  placeholder="Search"
                  className="message-table__filter-search-box search_bg"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
  
            {filteredData && (filteredData.uncategorizedFiles?.length > 0 || filteredData.categories?.length > 0) ? (
            <CategoryTable 
              currentItems={filteredData}
              draggable={true}
              showAddFilePopup={handleShowFilePopup}
              // showAddCategoryPopup={setShowAddCategoryPopup}
              isCategory={isCategory}
              handlePopupClose={handlePopupClose}
              searchTerm={search}
            />
          ) : (
              <p className="text-gray-600">
                You do not have any categories or documents defined. Select one of the buttons above to get started.
              </p>
            )}
          </div>
        </div>
  
        {(showAddCategoryPopup || showAddFilePopup || showAddSubcategoryPopup) && (
            <AccessControl
            feature={permissions.static.DocAndImages.addCategoryFile}
            permissionMessage={true}
            ifNotAllowed={
              <div className="permission-denied-container permission-denied-top">
                <h2>Permission Required</h2>
                <p>You need additional permissions to add files or categories. Please contact your administrator.</p>
              </div>
            }>
            <AddCategory
              mode={showAddCategoryPopup ? "CATEGORY" : "FILE"}
              data={
                showAddCategoryPopup 
                  ? { categoryId: selectedCategoryId }
                  : showAddFilePopup && typeof showAddFilePopup === 'object'
                    ? showAddFilePopup  // Pass the full category data object
                    : { categoryId: selectedCategoryId }
              }
              isCategory={isCategory}
              onCancel={handlePopupClose}
              saraNodeId={saraNodeId}
              catmoNodeId={catmoNodeId}
            />
          </AccessControl>
        )}
      </div>
    );
  };
  
  export default DocumentsInterface;